export function setHostname(hostname: string): void {
  Object.defineProperty(window, 'location', {
    value: {
      hostname
    },
    writable: true
  });
}
